import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import {
  BRAND_DETAIL_NOTICE_PRODUCT_FILTER_OPTION_MODEL,
  BRAND_DETAIL_NOTICE_PRODUCT_SORT_OPTION_MODEL,
} from '../../../../../store/modules/brand/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const BrandDetailNoticeProductList = (props) => {
  const { listInfo, getList, getBrandDetailNoticeExcelDownload, summary } = props;
  const { list, filterOption, pagination, sortOption } = listInfo;

  return (
    <Panel className="brand-detail-notice-product-list">
      <div className="panel-header">
        <div className="title">상품 공지사항 리스트</div>
      </div>

      <div className="panel-body">
        <TableWithSummary
          data={list}
          totalCnt={summary.totalCnt}
          initialOption={{
            filterOption: BRAND_DETAIL_NOTICE_PRODUCT_FILTER_OPTION_MODEL,
            sortOption: BRAND_DETAIL_NOTICE_PRODUCT_SORT_OPTION_MODEL,
            pagination: LIST_PAGINATION_MODEL,
          }}
          isStriped={true}
          emptyText="요청하신 검색 필터로 검색된 상품 공지사항 리스트가 없습니다."
          showPagination
          filterOption={filterOption}
          sortOption={sortOption}
          pagination={pagination}
          getList={getList}
          getExcelDownload={getBrandDetailNoticeExcelDownload}
          columns={(utils) =>
            columns({
              ...utils,
            })
          }
        />
      </div>
    </Panel>
  );
};

export default BrandDetailNoticeProductList;
